import React, { useState } from 'react';
import classes from '../pages.module.css';
import { Container } from "react-bootstrap";
import TextCol from "../../components/Ui/text/textCol";
import BtnDownload from '../../components/Ui/button/btnDownload';

const Alfoplus2 = () => {
    const [texts, settexts] = useState([
        {id:1, content: 'Первое полностью уличное решение, поддерживающее модуляцию 4096QAM'},
        {id:2, content: 'Полностью уличное решение с максимальной пропускной способностью, 2 Гбит/с без сжатия в одном ODU'},
        {id:3, content: 'Интегрированная конфигурация 2 + 0 Xpic для максимальной компактности'},
        {id:4, content: 'Первый полностью уличное решение, поддерживающее два канала 80/112 МГц в одном ODU'},
        {id:5, content: 'Стандартные лицензированные полосы частот от 6 до 42 ГГц'},
        {id:6, content: 'Порт трафика 10 Гбит/с'},
    ])
    return(
        <>
            <div className={classes.topBox}>
                <Container fluid="md">
                    <div className={classes.topboxBody}>
                        <span>радиорелейное оборудование</span>
                        <h1>ALFOplus2</h1>
                        <p>Решение полностью уличного исполнения, обеспечивающее гарантированную пропускную способность 2 Гбит/с без сжатия, имея самые компактные размеры и не занимая площади внутри помещения. Это сбалансированное по стоимости владения оборудование, работающее в стандартных лицензированных диапазонах частот, оно проверено на практике во многих сетях LTE и LTE-A, а также применяется в частных сетях и у поставщиков услуг Интернета (ISP) благодаря своей исключительной универсальности.</p>
                    </div>
                </Container>
                <div className={classes.topBg_small}></div>
            </div>
            <TextCol texts={texts} />
            <BtnDownload title="Скачать спецификацию" url='/src/download/test.txt' />
        </>
    )
}

export default Alfoplus2;